module.exports = __webpack_public_path__ + "static/media/GIOCODIG.f9506f50.svg";